import {
  useCollectionItemQuery,
  useCollectionsQueries,
} from "../../../hooks/queries/useCollectionsQueries";
import { LearningSetTypes } from "../../../interfaces/AthenaResources";
import { Pagetype } from "../../../interfaces/Config";
import useWorkModeEntryLearningSetIds from "../hooks/useWorkModeEntryLearningSetIds";

export const useTutos = (
  opts?: Parameters<typeof useCollectionsQueries>[2],
) => {
  const tutoCollectionsIds = useWorkModeEntryLearningSetIds(
    Pagetype.WORKMODE_TUTO,
  );
  return useCollectionsQueries(
    LearningSetTypes.Tutorial,
    tutoCollectionsIds,
    opts,
  );
};

export const useTuto = (tutoId: string | undefined) => {
  return useCollectionItemQuery(LearningSetTypes.Tutorial, tutoId);
};
